interface GallerySectionProps {
  isDarkMode?: boolean;
}

export default function GallerySection({ isDarkMode = false }: GallerySectionProps) {
  const images = [
    {
      url: 'https://static.readdy.ai/image/ceffbd0e215ee7f6434042c96230b75d/b312215b7900b0142ee933b291352810.jpeg',
      title: '2026年二月份活動',
      label: '1970年 世界盃賽',
      youtubeUrl: 'https://www.youtube.com/embed/KbiKCSgZUR0?autoplay=1'
    },
    {
      url: 'https://static.readdy.ai/image/ceffbd0e215ee7f6434042c96230b75d/be84bc43a3698dbc8e08527f1eb032e0.jpeg',
      title: '2026年二月份活動',
      label: '蝴蝶盃',
      youtubeUrl: 'https://www.youtube.com/embed/_Di8y13kdcE?autoplay=1'
    },
    {
      url: 'https://static.readdy.ai/image/ceffbd0e215ee7f6434042c96230b75d/eba6807df19112ce9596dcf97463c529.png',
      title: '2026年二月份活動',
      label: '長城內部賽',
      youtubeUrl: 'https://www.youtube.com/embed/o_DcsYBDwZA?autoplay=1'
    },
    {
      url: 'https://static.readdy.ai/image/ceffbd0e215ee7f6434042c96230b75d/fa967d2bf478458f25ec8b481bbb188b.jpeg',
      title: '2026年二月份活動',
      label: '港邕盃',
      youtubeUrl: 'https://www.youtube.com/embed/98DKiMlF2fY?autoplay=1'
    }
  ];

  const handleImageClick = (youtubeUrl: string) => {
    window.open(youtubeUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="gallery" className={`py-24 ${isDarkMode ? 'bg-gray-800' : 'bg-gradient-to-b from-gray-50 to-white'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className={`text-5xl md:text-6xl font-black mb-6 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
            精彩相簿
          </h2>
          <div className="w-24 h-1.5 bg-emerald-600 mx-auto mb-6"></div>
          <p className={`text-xl max-w-3xl mx-auto ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
            記錄每一個精彩時刻，點擊觀看 YouTube 視頻
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {images.map((image, index) => (
            <div key={index} className={`rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all ${isDarkMode ? 'bg-gray-700' : 'bg-white'}`}>
              {/* Top Label */}
              <div className="px-6 py-4 bg-gradient-to-r from-emerald-600 to-emerald-700 text-white">
                <h3 className="text-lg font-bold text-center">
                  {image.label}
                </h3>
              </div>
              
              {/* Image Container */}
              <div
                className="group relative overflow-hidden cursor-pointer bg-black"
                onClick={() => handleImageClick(image.youtubeUrl)}
              >
                <div className="relative h-80 w-full overflow-hidden">
                  <img
                    src={image.url}
                    alt={image.title}
                    className="w-full h-full object-cover object-top transition-all duration-500 group-hover:scale-110 group-hover:opacity-75"
                  />
                  
                  {/* Dark Overlay */}
                  <div className="absolute inset-0 bg-black/30 group-hover:bg-black/50 transition-all duration-300"></div>
                  
                  {/* YouTube Play Button - Always Visible */}
                  <div className="absolute inset-0 flex items-center justify-center z-10">
                    <div className="w-20 h-20 flex items-center justify-center bg-red-600 rounded-full shadow-2xl transform transition-all duration-300 group-hover:scale-125 group-hover:bg-red-700">
                      <i className="ri-play-fill text-4xl text-white ml-1"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="https://www.youtube.com/watch?v=-qodPCituDc&list=RD-qodPCituDc&start_radio=1&autoplay=1"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-10 py-4 bg-red-600 hover:bg-red-700 text-white text-lg font-bold rounded-full transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-youtube-fill text-2xl mr-2"></i>
            訂閱 YouTube 頻道
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}